var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-newsletter__input input-newsletter-button"},[_c('button',{staticClass:"input-newsletter-button__input",attrs:{"type":_vm.type,"name":_vm.name,"value":_vm.value,"disabled":_vm.disabled,"aria-disabled":_vm.disabled}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }